import React, {useEffect} from "react";
import NoPhotoImage from "../../assets/img/no-image.jpg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faPlus, faRemove, faEdit, faEllipsisVertical} from "@fortawesome/free-solid-svg-icons";
import {Link, useNavigate} from "react-router-dom";
import EntityApi from "../../api/EntityApi";
import ModalConfirm from "../main/ModalConfirm";
import useAuth from "../../hooks/useAuth";
import RequestApi from "../../api/RequestApi";
import { Modal } from 'antd';
import { useDispatch } from "react-redux";
import { updateDataThunk } from "../../redux/slices/cartSlice";

const { confirm } = Modal;

const ListItem = ({ id, title, image, code, access, price, active, stickerNew, stickerHit}) => {

    const { roles } = useAuth();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const popperRef = React.useRef(null);
    const [isPopperOpen, setIsPopperOpen] = React.useState(false);
    const [isRemoveOpen, setIsRemoveOpen] = React.useState(false);
    const [isShow, setIsShow] = React.useState(true);
    const [isLoadingOrder, setIsLoadingOrder] = React.useState(false);
    const [isOpenPreview, setIsOpenPreview] = React.useState(false);
    const [contentPreview, setContentPreview] = React.useState('');
    const [titlePreview, setTitlePreview] = React.useState('');
    const [contentPreviewTabs, setContentPreviewTabs] = React.useState([]);
    const [contentPreviewTabsActive, setContentPreviewTabsActive] = React.useState(0);
    const [contentPreviewTabsContent, setContentPreviewTabsContent] = React.useState([]);
    const [isOpenPreviewTabs, setIsOpenPreviewTabs] = React.useState(false);

    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.composedPath().includes(popperRef.current)) {
                setIsPopperOpen(false);
            }
        }
        document.body.addEventListener('click', handleClickOutside);
        return () => {
            document.body.removeEventListener('click', handleClickOutside);
        }

    }, [])

    const onRemove = () => {
        EntityApi.delete('private/product', id).then((data) => {
            if (data.status === 'success') {
                setIsRemoveOpen(false);
                setIsShow(false);
            }
        })
    }

    const onBuy = (id) => {
        /*setIsLoadingOrder(true);
        RequestApi.post('order/create/product', {
            product_id: id
        }).then((data) => {
            setIsLoadingOrder(false);
            if (data.status === RequestApi.STATUS_SUCCESS) {
                window.location.href = data.content.item.payment_url;
            }
        })*/
        //navigate('/public/order/' + id);
        RequestApi.get('private/cart/add/' + id).then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                dispatch(updateDataThunk({}));
                confirm({
                    content: 'Курс добавлен в корзину',
                    okText: 'Оформить заказ',
                    cancelText: 'Вернуться',
                    maskClosable: true,
                    onOk: () => {
                        navigate('/cabinet/cart');
                    }
                });
            } else {
                Modal.error({
                    title: 'Ошибка',
                    content: 'Ошибка добавления курса в корзину',
                    maskClosable: true
                });
            }
        });

    }

    const onBuyFast = (id) => {
        navigate('/public/order/' + id);
    }

    const onDetail = () => {
        if (access) {
            navigate('/cabinet/catalog/course/' + id, {state: { prevPath: window.location.pathname }});
        }
    }

    const onSelectPreviewTab = (index) => {
        setContentPreviewTabsActive(index);
    }

    const onPreview = () => {
        setContentPreviewTabsActive(0);
        setContentPreviewTabs([]);
        setContentPreviewTabsContent([]);
        RequestApi.get('private/product/preview/' + id).then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                let tabTitles = [];
                let tabContents = [];
                if (data.content.item.description_tabs.length > 0) {
                    data.content.item.description_tabs.forEach((tab) => {
                        tabTitles.push(tab.title);
                        tabContents.push(tab.text);
                    })
                    setContentPreviewTabs(tabTitles);
                    setContentPreviewTabsContent(tabContents);
                    setIsOpenPreviewTabs(true);
                } else {
                    setContentPreview(data.content.item.description);
                    setIsOpenPreview(true);
                }
                setTitlePreview(data.content.item.title);

            } else {
                Modal.error({
                    title: 'Ошибка',
                    content: 'Данные по курсу не получены',
                    maskClosable: true
                });
            }
        })
    }

    useEffect(() => {
        if (isOpenPreview) {
            document.getElementsByTagName('html')[0].style.overflow = 'hidden';
        } else {
            document.getElementsByTagName('html')[0].style.overflow = '';
        }
    }, [isOpenPreview])

    return <>{
        isShow && <div className="card">
                     { roles.includes('ROLE_ADMIN') &&
        <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3"></div>
            <div className="inline-flex">
                <button ref={popperRef} onClick={(evt) => setIsPopperOpen(true)} className="popper-ref btn h-8 w-8 rounded-full p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                    <FontAwesomeIcon icon={faEllipsisVertical} />
                </button>
                <div className={`popper-root${isPopperOpen ? ' show' : ''}`} data-popper-placement="right" style={{'position': 'absolute', 'right': 0}}>
                    <div className="popper-box rounded-md border  border-slate-150 bg-white py-1.5 font-inter dark:border-navy-500 dark:bg-navy-700">
                        <ul>
                            <li>
                                <Link to={`/cabinet/catalog/form/course/${id}`} state={{ prevPath: window.location.pathname }} onClick={() => setIsPopperOpen(false)} className="flex h-8 items-center space-x-3 px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                                    <FontAwesomeIcon icon={faEdit}/>
                                    <span> Изменить</span></Link>
                            </li>
                            <li>
                                <div onClick={() => setIsRemoveOpen(true)} className="flex h-8 cursor-pointer items-center space-x-3 px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                                    <FontAwesomeIcon icon={faRemove}/>
                                    <span> Удалить</span></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
                     }
        <div className="p-2.5">
            <div onClick={() => onPreview()} style={{backgroundImage: 'url(' + (image ?? NoPhotoImage) +')', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}} className={`h-48 w-full hover-child-shower relative rounded-lg object-cover object-center ${access ? ' cursor-pointer' : ''}`}>
                <div className={'flex justify-center hider'}>
                    <button className={'rounded-lg bg-white p-2 mx-auto absolute shadow-lg text-dark'}
                            style={{top: '40%'}}>Описание курса
                    </button>
                </div>
                <div className={'absolute flex pt-2 gap-2'} style={{paddingLeft: '0.5rem'}}>
                    {
                        stickerNew &&
                        <div className={'tag rounded bg-info text-white '}>Новинка</div>
                    }
                    {
                        stickerHit &&
                        <div className={'tag rounded bg-error text-white '}>Хит продаж</div>
                    }
                </div>
            </div>
            {/*<img
                src={image ?? NoPhotoImage}
                className="h-48 w-full rounded-lg object-cover object-center"
                alt="image"
            />*/}
        </div>
        <div className="flex grow flex-col px-4 pb-5 pt-1 text-center sm:px-5">
            {/*<div><a className="text-xs+ text-info" href="#">Frameworks</a></div>
                     <div className="mt-1">
                         <a
                             href="#"
                             className="text-lg font-medium text-slate-700 hover:text-primary focus:text-primary dark:text-navy-100 dark:hover:text-accent-light dark:focus:text-accent-light"
                         >What is Tailwind CSS?</a
                         >
                     </div>
                     <div className="my-2 flex items-center space-x-3 text-xs">
                         <div className="h-px flex-1 bg-slate-200 dark:bg-navy-500"></div>
                         <p>June 23, 2021</p>
                         <div className="h-px flex-1 bg-slate-200 dark:bg-navy-500"></div>
                     </div>*/}
            <p onClick={() => onDetail()} className="my-2 grow text-left" style={access ? {cursor: 'pointer'} : {}}>
                [Код: {code}] {title}
            </p>
            {!active && <span style={{color: 'red'}}>Не активен</span>}
            {
                price > 0 && <p className={'text-left font-bold text-primary'}>
                Цена: {price} руб.
                </p>
            }
            <div className="mt-6 grid w-full grid-cols-2 gap-1">
                {access &&
                    <Link to={`/cabinet/catalog/course/${id}`}
                          className="btn mt-4 bg-slate-150 font-medium text-slate-800 hover:bg-slate-200 focus:bg-slate-200 active:bg-slate-200/80 dark:bg-navy-500 dark:text-navy-50 dark:hover:bg-navy-450 dark:focus:bg-navy-450 dark:active:bg-navy-450/90">
                        Обучение
                    </Link>
                }
                {!access && !isLoadingOrder && price > 0 &&
                    <button onClick={() => onBuyFast(id)}
                            className="btn mt-4 bg-primary font-medium text-white hover:bg-primary-focus hover:shadow-lg hover:shadow-primary/50 focus:bg-primary-focus focus:shadow-lg focus:shadow-primary/50 active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:hover:shadow-accent/50 dark:focus:bg-accent-focus dark:focus:shadow-accent/50 dark:active:bg-accent/90">
                        Купить сейчас
                    </button>
                }
                <button onClick={() => onBuy(id)}
                        className="btn mt-4 bg-primary font-medium text-white hover:bg-primary-focus hover:shadow-lg hover:shadow-primary/50 focus:bg-primary-focus focus:shadow-lg focus:shadow-primary/50 active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:hover:shadow-accent/50 dark:focus:bg-accent-focus dark:focus:shadow-accent/50 dark:active:bg-accent/90">
                    В корзину
                </button>
                {
                    isLoadingOrder && <button>Подождите, идет загрузка..</button>
                }
            </div>
        </div>
            <ModalConfirm title={'Удаление курса'} text={'Вы действительно хотите удалить этот курс?'}
                          cancelText={"Отменить"} confirmText={"Удалить"} onConfirm={onRemove} isOpen={isRemoveOpen}
                          onClose={() => setIsRemoveOpen(false)}/>
            <Modal title="Описание курса" width={'50%'} footer={null} open={isOpenPreview} maskClosable={true} onCancel={() => setIsOpenPreview(false)}>
                <h1 className={'font-bold'}>{titlePreview}</h1>
                <div className={'pt-2'} dangerouslySetInnerHTML={{__html: contentPreview}}></div>
            </Modal>
            <Modal title="Описание курса" width={'80%'} footer={null} open={isOpenPreviewTabs} maskClosable={true} onCancel={() => setIsOpenPreviewTabs(false)}>
                <h1 className={'font-bold'}>{titlePreview}</h1>
                <div className={'pt-2'}>
                    <div className="tabs-list flex preview__tabs-list">
                        {
                            contentPreviewTabs.map((tab, index) => {
                                return <button key={index} onClick={() => onSelectPreviewTab(index)} className={`tab btn shrink-0 rounded-none border-b-2 px-3 py-2 font-medium ${contentPreviewTabsActive === index ? ' border-primary dark:border-accent text-primary dark:text-accent-light' : ''}`}>
                                    {tab}
                                </button>
                            })
                        }
                    </div>
                    <div className="pt-4">
                        {
                            contentPreviewTabsContent.map((content, index) => {
                                return <div key={index} className={`tab-content tab-shift-left ${contentPreviewTabsActive === index ? ' is-active' : ''}`} dangerouslySetInnerHTML={{__html: content}}></div>
                            })
                        }
                    </div>
                </div>
            </Modal>
        </div>}</>
}

export default ListItem;
